import React from "react"
import PartnersHero from "./PartnersPage/PartnersHero"
import StatisticsCards from "./StatisticsCards"
import WhyChooseAqua from "./PartnersPage/WhyChooseAqua"
import CustomMadeVersions from "./PartnersPage/CustomMadeVersions"
import PartnerLogos from "./PartnerLogos"
import BubblesBg from "./BubblesBg/BubblesBg"

function PartnersPage() {
  return (
    <>
      <PartnersHero />
      <StatisticsCards />
      <WhyChooseAqua />
      <CustomMadeVersions />
      <PartnerLogos />
      <BubblesBg />
    </>
  )
}

export default PartnersPage